import fileSys from "../fileoprators/fileSystem";
import SettingsOprator from "./settingsoprator";
const DEFAULTSET = {
  username: "Admin",
  password: "",
  serverip: "127.0.0.1",
  serverport: 8080,
  sslport: 4430,
  serverssl: 0
};
class RemoteServer extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("remoteserver.json"), DEFAULTSET);
  }
  getServerSettings() {
    return this.getSettings();
  }
  saveServerSettings(settings) {
    this.saveSettings(settings);
  }
}
export default RemoteServer;



// WEBPACK FOOTER //
// ./src/settings/remoteserver.js